module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 175);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 12:
/***/ (function(module, exports) {

module.exports = require("setaria-ui/lib/input");

/***/ }),

/***/ 13:
/***/ (function(module, exports) {

module.exports = require("setaria-ui/lib/mixins/migrating");

/***/ }),

/***/ 14:
/***/ (function(module, exports) {

module.exports = require("babel-helper-vue-jsx-merge-props");

/***/ }),

/***/ 17:
/***/ (function(module, exports) {

module.exports = require("setaria-ui/lib/utils/popup");

/***/ }),

/***/ 175:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: external "babel-helper-vue-jsx-merge-props"
var external_babel_helper_vue_jsx_merge_props_ = __webpack_require__(14);
var external_babel_helper_vue_jsx_merge_props_default = /*#__PURE__*/__webpack_require__.n(external_babel_helper_vue_jsx_merge_props_);

// EXTERNAL MODULE: ./packages/card/src/main.vue + 4 modules
var main = __webpack_require__(38);

// EXTERNAL MODULE: ./packages/dialog/src/component.vue + 4 modules
var component = __webpack_require__(39);

// EXTERNAL MODULE: ./packages/json-form/src/json-form.js
var json_form = __webpack_require__(37);

// EXTERNAL MODULE: external "setaria-ui/lib/utils/dom"
var dom_ = __webpack_require__(4);

// EXTERNAL MODULE: external "setaria-ui/lib/utils/util"
var util_ = __webpack_require__(2);

// CONCATENATED MODULE: ./packages/pro-form/src/pro-form.js







var NON_INITIAL = 'nonInitial';
// const INITIALED = 'initialed';

/** 配置表单列变化的容器宽度断点 */
var BREAKPOINTS = {
  vertical: [
  // [breakpoint, cols, layout]
  [513, 1, 'vertical'], [785, 2, 'vertical'], [1057, 3, 'vertical'],
  // ! FIXME 4列情况下有错误，需要修正
  [Infinity, 3, 'vertical']],
  default: [[513, 1, 'vertical'], [701, 2, 'vertical'], [1062, 3, 'horizontal'], [1352, 3, 'horizontal'],
  // ! FIXME 4列情况下有错误，需要修正
  [Infinity, 3, 'horizontal']]
};

/* harmony default export */ var pro_form = ({
  name: 'ElProForm',
  componentName: 'ElProForm',
  props: {
    model: {
      type: Object
    },
    type: {
      type: String,
      default: ''
    },
    schema: {
      type: Object,
      required: true
    },
    uiSchema: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    afterSubmit: {
      type: Function
    },
    expand: {
      type: Boolean,
      default: false
    },
    title: String,
    // 提交按钮相关配置
    submitter: Boolean | Object,
    // type为card时的props
    cardAttrs: Object,
    // type为modalForm时的props
    dialogAttrs: Object
  },
  data: function data() {
    return {
      isSubmiting: false,
      isMounted: false,
      innerExpand: false,
      width: null,
      currentDisplayTotalColSpan: 0,
      totalColSpan: 0,
      isShowModalForm: false,
      formRenderKey: NON_INITIAL
    };
  },

  watch: {
    expand: {
      immediate: true,
      handler: function handler(val) {
        this.innerExpand = val;
      }
    },
    innerExpand: function innerExpand(val) {
      this.$emit('update:expand', val);
    },
    isShowModalForm: function isShowModalForm(val) {
      this.$emit('visibleChange', val);
    }
  },
  computed: {
    direction: function direction() {
      var ret = '';
      var type = this.type;

      switch (type) {
        case 'queryFilter':
          ret = 'default';
          break;
        default:
          ret = 'vertical';
      }
      return ret;
    },
    currentColumns: function currentColumns() {
      var direction = this.direction,
          widthNumber = this.widthNumber;

      var breakPoints = BREAKPOINTS[direction];
      var breakPoint = Object(util_["arrayFind"])(breakPoints, function (item) {
        return widthNumber < item[0];
      });
      return breakPoint ? breakPoint[1] : 0;
    },
    widthNumber: function widthNumber() {
      var width = this.width;

      if (Object(util_["isEmpty"])(width)) {
        return 0;
      }
      return parseInt(width.replace('px', ''), 10);
    },
    innerUiSchema: function innerUiSchema() {
      var _this = this;

      var ret = {};
      if (!this.isMounted) {
        return ret;
      }
      this.totalColSpan = 0;
      this.currentDisplayTotalColSpan = 0;
      var currentColumns = this.currentColumns,
          innerExpand = this.innerExpand,
          schema = this.schema,
          type = this.type,
          uiSchema = this.uiSchema;

      Object.keys(schema.properties).forEach(function (schemaKey, index) {
        var uiProperty = uiSchema[schemaKey];
        if (Object(util_["isEmpty"])(uiSchema[schemaKey])) {
          uiProperty = {};
        }
        ret[schemaKey] = uiProperty;
        if (type === 'queryFilter') {
          var propertyColspan = uiProperty['ui:colspan'];
          propertyColspan = typeof propertyColspan === 'number' ? propertyColspan : 1;
          // 收起的场合
          if (!innerExpand) {
            if (currentColumns === 1 && index === 0) {
              uiProperty['ui:hidden'] = false;
              // 只显示一行表单项目，其余的隐藏
            } else if (_this.currentDisplayTotalColSpan + propertyColspan + 1 > currentColumns) {
              uiProperty['ui:hidden'] = true;
            } else {
              uiProperty['ui:hidden'] = false;
            }
            // 展开的场合
          } else {
            uiProperty['ui:hidden'] = false;
          }
          var isCurrentRowEnough = currentColumns - _this.currentDisplayTotalColSpan % currentColumns < propertyColspan;
          if (propertyColspan > currentColumns) {
            propertyColspan = currentColumns;
          }
          // 隐藏的项目不统计
          if (uiProperty['ui:hidden'] !== true) {
            if (isCurrentRowEnough) {
              // 如果当前行空余位置放不下，那么折行
              _this.currentDisplayTotalColSpan += currentColumns - _this.currentDisplayTotalColSpan % currentColumns;
            }
            _this.currentDisplayTotalColSpan += propertyColspan;
          }
          if (isCurrentRowEnough) {
            _this.totalColSpan += currentColumns - _this.totalColSpan % currentColumns;
          }
          _this.totalColSpan += propertyColspan;
        }
      });
      return ret;
    },
    queryFilterColumnConfig: function queryFilterColumnConfig() {
      var currentColumns = this.currentColumns,
          currentDisplayTotalColSpan = this.currentDisplayTotalColSpan;

      var currentColspan = 24 / currentColumns;
      var ret = {
        span: currentColspan
      };
      if (!this.isMounted) {
        return ret;
      }
      var leaveSpan = currentColumns - currentDisplayTotalColSpan % currentColumns - 1;
      ret.offset = leaveSpan * currentColspan;
      return ret;
    },
    fields: function fields() {
      if (this.$refs.proForm) {
        return this.$refs.proForm.fields;
      }
      return [];
    }
  },
  created: function created() {},
  mounted: function mounted() {
    this.handleResize();
    this.isMounted = true;
    window.addEventListener('resize', this.handleResize);
    // 初始化时，需要等自组件渲染完才能从子组件取得当前选择值
    this.$nextTick(function () {
      // this.formRenderKey = INITIALED;
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },

  methods: {
    getFields: function getFields() {
      return this.$refs.proForm && this.$refs.proForm.fields;
    },
    resetFields: function resetFields() {
      this.$refs.proForm.resetFields();
    },
    handleResize: function handleResize() {
      this.width = Object(dom_["getStyle"])(this.$el, 'width');
    },
    handleExpand: function handleExpand() {
      this.innerExpand = !this.innerExpand;
    },

    /**
     * 表单提交事件处理
     * @public
     */
    handleSubmit: function handleSubmit() {
      var _this2 = this;

      var afterSubmit = this.afterSubmit,
          model = this.model,
          type = this.type;

      this.$refs.proForm.validate(function (isValid) {
        if (isValid) {
          _this2.isSubmiting = true;
          if (typeof afterSubmit === 'function') {
            var result = afterSubmit(model);
            if (result.then) {
              result.then(function () {
                _this2.isSubmiting = false;
                if (type === 'modalForm' && _this2.isShowModalForm) {
                  _this2.isShowModalForm = false;
                }
              });
            }
          }
          _this2.$emit('submit');
        }
      });
    },
    handleReset: function handleReset() {
      this.resetFields();
      this.$emit('clear');
    },
    handleCancel: function handleCancel() {
      this.isShowModalForm = false;
    },
    handleChange: function handleChange(key, value, object) {
      this.$emit('change', key, value, object);
    },
    handleModalButtonClick: function handleModalButtonClick(evt) {
      this.isShowModalForm = !this.isShowModalForm;
    },
    validate: function validate(callbackFunc) {
      return this.$refs.proForm.validate(callbackFunc);
    }
  },
  render: function render(h) {
    var _this3 = this;

    var $attrs = this.$attrs,
        $listeners = this.$listeners,
        $slots = this.$slots,
        $scopedSlots = this.$scopedSlots,
        cardAttrs = this.cardAttrs,
        currentColumns = this.currentColumns,
        dialogAttrs = this.dialogAttrs,
        innerExpand = this.innerExpand,
        model = this.model,
        isMounted = this.isMounted,
        isSubmiting = this.isSubmiting,
        isShowModalForm = this.isShowModalForm,
        innerUiSchema = this.innerUiSchema,
        queryFilterColumnConfig = this.queryFilterColumnConfig,
        schema = this.schema,
        totalColSpan = this.totalColSpan,
        type = this.type,
        title = this.title,
        submitter = this.submitter,
        handleExpand = this.handleExpand,
        handleSubmit = this.handleSubmit,
        handleChange = this.handleChange,
        handleModalButtonClick = this.handleModalButtonClick;

    if (!isMounted) {
      return h('div');
    }
    var attributes = {
      attrs: $attrs,
      listeners: $listeners
    };
    // console.log('------------------------------------------', innerExpand);
    // console.log('当前宽度', widthNumber);
    // console.log('当前每行列数', currentColumns);
    // console.log('元素所占列数总和', currentDisplayTotalColSpan, totalColSpan);
    var getExpandTextLabel = function getExpandTextLabel() {
      return innerExpand ? h('div', [h('i', { 'class': 'el-icon-arrow-up' }), h('span', ['\u6536\u8D77'])]) : h('div', [h('i', { 'class': 'el-icon-arrow-down' }), h('span', ['\u5C55\u5F00'])]);
    };
    /**
     * 正常表单的操作区域
     */
    var getNormalFormControlContainer = function getNormalFormControlContainer() {
      var handleSubmit = _this3.handleSubmit,
          handleReset = _this3.handleReset;

      return h(
        'div',
        { 'class': 'pro-form-control-button-container', slot: 'button' },
        [h(
          'el-button',
          {
            attrs: { type: 'primary', loading: isSubmiting },
            on: {
              'click': handleSubmit
            }
          },
          ['\u63D0\u4EA4']
        ), h(
          'el-button',
          {
            on: {
              'click': handleReset
            }
          },
          ['\u91CD\u7F6E']
        )]
      );
    };
    /**
     * 渲染查询筛选的操作区域
     */
    var getQueryFillterControlContainer = function getQueryFillterControlContainer() {
      var handleSubmit = _this3.handleSubmit,
          handleReset = _this3.handleReset,
          $attrs = _this3.$attrs;

      return h(
        'el-col',
        {
          attrs: {
            span: queryFilterColumnConfig.span,
            offset: queryFilterColumnConfig.offset
          },
          slot: 'formItems',
          'class': 'el-pro-form__control' },
        [h('el-form-item', [$attrs.labelPosition === 'top' ? h(
          'span',
          { slot: 'label' },
          ['\xA0']
        ) : null, h(
          'el-button',
          {
            attrs: {
              type: 'primary',
              icon: 'el-icon-search',

              loading: isSubmiting },
            on: {
              'click': handleSubmit
            }
          },
          ['\u641C\u7D22']
        ), h(
          'el-button',
          {
            on: {
              'click': handleReset
            },
            attrs: { icon: 'el-icon-refresh-left' }
          },
          ['\u91CD\u7F6E']
        ), h(
          'el-button',
          {
            attrs: {
              type: 'text'
            },
            on: {
              'click': handleExpand
            },

            'class': 'control__expand-button' },
          [totalColSpan >= currentColumns ? getExpandTextLabel() : null]
        )])]
      );
    };
    /**
     * ModalForm的操作区域
     */
    var getModalFormControlContainer = function getModalFormControlContainer() {
      var handleSubmit = _this3.handleSubmit,
          handleCancel = _this3.handleCancel;

      return h(
        'div',
        { 'class': 'pro-form-control-button-container', slot: 'button' },
        [h(
          'el-button',
          {
            on: {
              'click': handleCancel
            }
          },
          ['\u53D6\u6D88']
        ), h(
          'el-button',
          {
            attrs: { type: 'primary', loading: isSubmiting },
            on: {
              'click': handleSubmit
            }
          },
          ['\u63D0\u4EA4']
        )]
      );
    };
    var getControlButton = function getControlButton() {
      if (submitter === false) {
        return null;
      }
      if (Object(util_["isEmpty"])(type)) {
        return getNormalFormControlContainer();
      } else if (type === 'queryFilter') {
        return getQueryFillterControlContainer();
      }
      return null;
    };
    var formRender = h(
      json_form["a" /* default */],
      external_babel_helper_vue_jsx_merge_props_default()([{
        ref: 'proForm',
        'class': 'el-pro-form',
        attrs: { model: model,
          schema: schema,
          uiSchema: innerUiSchema,
          columns: currentColumns
        },
        scopedSlots: $scopedSlots,
        on: {
          'submit': handleSubmit,
          'change': handleChange
        }
      }, attributes]),
      [getControlButton()]
    );
    var cardFormAttrs = {
      attrs: cardAttrs
    };
    var cardForm = h(
      main["a" /* default */],
      external_babel_helper_vue_jsx_merge_props_default()([{
        attrs: { header: title }
      }, cardFormAttrs]),
      [formRender]
    );
    var onListener = {
      'update:visible': function updateVisible(val) {
        _this3.isShowModalForm = val;
      }
    };
    var modalFormAttrs = {
      attrs: dialogAttrs
    };
    var modalDialog = h(
      component["a" /* default */],
      external_babel_helper_vue_jsx_merge_props_default()([{
        attrs: {
          visible: isShowModalForm,
          title: title
        }
      }, modalFormAttrs, { on: onListener }]),
      [formRender, h(
        'span',
        { slot: 'footer', 'class': 'dialog-footer' },
        [getModalFormControlContainer()]
      )]
    );
    if (type === 'cardForm') {
      return cardForm;
    } else if (type === 'modalForm') {
      return h(
        'div',
        { 'class': 'el-modal-form' },
        [h(
          'div',
          {
            on: {
              'click': handleModalButtonClick
            }
          },
          [$slots.default]
        ), modalDialog]
      );
    }
    return formRender;
  },

  components: {
    ElCard: main["a" /* default */],
    ElDialog: component["a" /* default */],
    ElJsonForm: json_form["a" /* default */]
  }
});
// CONCATENATED MODULE: ./packages/pro-form/index.js


/* istanbul ignore next */
pro_form.install = function install(Vue) {
  Vue.component(pro_form.name, pro_form);
};

/* harmony default export */ var packages_pro_form = __webpack_exports__["default"] = (pro_form);

/***/ }),

/***/ 19:
/***/ (function(module, exports) {

module.exports = require("setaria-ui/lib/tooltip");

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("setaria-ui/lib/utils/util");

/***/ }),

/***/ 20:
/***/ (function(module, exports) {

module.exports = require("setaria-ui/lib/utils/schema");

/***/ }),

/***/ 27:
/***/ (function(module, exports) {

module.exports = require("setaria-ui/lib/select");

/***/ }),

/***/ 32:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/form/src/form-item.vue?vue&type=template&id=b6f3db6c&
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "el-form-item",
      class: [
        {
          "el-form-item--feedback": _vm.elForm && _vm.elForm.statusIcon,
          "is-error": _vm.validateState === "error",
          "is-validating": _vm.validateState === "validating",
          "is-success": _vm.validateState === "success",
          "is-required": _vm.isRequired || _vm.required,
          "is-no-asterisk": _vm.elForm && _vm.elForm.hideRequiredAsterisk
        },
        _vm.sizeClass ? "el-form-item--" + _vm.sizeClass : ""
      ]
    },
    [
      _c(
        "label-wrap",
        {
          attrs: {
            "is-auto-width": _vm.labelStyle && _vm.labelStyle.width === "auto",
            "update-all": _vm.form.labelWidth === "auto"
          }
        },
        [
          _vm.label || _vm.$slots.label
            ? _c(
                "label",
                {
                  staticClass: "el-form-item__label",
                  style: _vm.labelStyle,
                  attrs: { for: _vm.labelFor }
                },
                [
                  _vm._t("label", [
                    _vm._v(_vm._s(_vm.label + _vm.form.labelSuffix))
                  ]),
                  _vm.tooltip
                    ? _c(
                        "el-tooltip",
                        {
                          staticClass: "label__tooltip",
                          attrs: { content: _vm.tooltip, placement: "top" }
                        },
                        [_c("i", { staticClass: "el-icon-question" })]
                      )
                    : _vm._e()
                ],
                2
              )
            : _vm._e()
        ]
      ),
      _c(
        "div",
        { staticClass: "el-form-item__content", style: _vm.contentStyle },
        [
          _vm._t("default"),
          _c(
            "transition",
            { attrs: { name: "el-zoom-in-top" } },
            [
              _vm.validateState === "error" &&
              _vm.showMessage &&
              _vm.form.showMessage
                ? _vm._t(
                    "error",
                    [
                      _c(
                        "div",
                        {
                          staticClass: "el-form-item__error",
                          class: {
                            "el-form-item__error--inline":
                              typeof _vm.inlineMessage === "boolean"
                                ? _vm.inlineMessage
                                : (_vm.elForm && _vm.elForm.inlineMessage) ||
                                  false
                          }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.validateMessage) +
                              "\n        "
                          )
                        ]
                      )
                    ],
                    { error: _vm.validateMessage }
                  )
                : _vm._e()
            ],
            2
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/form/src/form-item.vue?vue&type=template&id=b6f3db6c&

// EXTERNAL MODULE: external "async-validator"
var external_async_validator_ = __webpack_require__(43);
var external_async_validator_default = /*#__PURE__*/__webpack_require__.n(external_async_validator_);

// EXTERNAL MODULE: external "setaria-ui/lib/mixins/emitter"
var emitter_ = __webpack_require__(5);
var emitter_default = /*#__PURE__*/__webpack_require__.n(emitter_);

// EXTERNAL MODULE: external "setaria-ui/lib/utils/merge"
var merge_ = __webpack_require__(9);
var merge_default = /*#__PURE__*/__webpack_require__.n(merge_);

// EXTERNAL MODULE: external "setaria-ui/lib/utils/util"
var util_ = __webpack_require__(2);

// EXTERNAL MODULE: external "setaria-ui/lib/tooltip"
var tooltip_ = __webpack_require__(19);
var tooltip_default = /*#__PURE__*/__webpack_require__.n(tooltip_);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/form/src/label-wrap.vue?vue&type=script&lang=js&


/* harmony default export */ var label_wrapvue_type_script_lang_js_ = ({
  props: {
    isAutoWidth: Boolean,
    updateAll: Boolean
  },

  inject: ['elForm', 'elFormItem'],

  render: function render() {
    var h = arguments[0];

    var slots = this.$slots.default;
    if (!slots) return null;
    if (this.isAutoWidth) {
      var autoLabelWidth = this.elForm.autoLabelWidth;
      var style = {};
      if (autoLabelWidth && autoLabelWidth !== 'auto') {
        var marginLeft = parseInt(autoLabelWidth, 10) - this.computedWidth;
        if (marginLeft) {
          style.marginLeft = marginLeft + 'px';
        }
      }
      return h(
        'div',
        { 'class': 'el-form-item__label-wrap', style: style },
        [slots]
      );
    } else {
      return slots[0];
    }
  },


  methods: {
    getLabelWidth: function getLabelWidth() {
      if (this.$el && this.$el.firstElementChild) {
        var computedWidth = window.getComputedStyle(this.$el.firstElementChild).width;
        return Math.ceil(parseFloat(computedWidth));
      } else {
        return 0;
      }
    },
    updateLabelWidth: function updateLabelWidth() {
      var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'update';

      if (this.$slots.default && this.isAutoWidth && this.$el.firstElementChild) {
        if (action === 'update') {
          this.computedWidth = this.getLabelWidth();
        } else if (action === 'remove') {
          this.elForm.deregisterLabelWidth(this.computedWidth);
        }
      }
    }
  },

  watch: {
    computedWidth: function computedWidth(val, oldVal) {
      if (this.updateAll) {
        this.elForm.registerLabelWidth(val, oldVal);
        this.elFormItem.updateComputedLabelWidth(val);
      }
    }
  },

  data: function data() {
    return {
      computedWidth: 0
    };
  },
  mounted: function mounted() {
    this.updateLabelWidth('update');
  },
  updated: function updated() {
    this.updateLabelWidth('update');
  },
  beforeDestroy: function beforeDestroy() {
    this.updateLabelWidth('remove');
  }
});
// CONCATENATED MODULE: ./packages/form/src/label-wrap.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_label_wrapvue_type_script_lang_js_ = (label_wrapvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./packages/form/src/label-wrap.vue
var label_wrap_render, label_wrap_staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_label_wrapvue_type_script_lang_js_,
  label_wrap_render,
  label_wrap_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "packages/form/src/label-wrap.vue"
/* harmony default export */ var label_wrap = (component.exports);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/form/src/form-item.vue?vue&type=script&lang=js&
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var form_itemvue_type_script_lang_js_ = ({
  name: 'ElFormItem',

  componentName: 'ElFormItem',

  mixins: [emitter_default.a],

  provide: function provide() {
    return {
      elFormItem: this
    };
  },


  inject: ['elForm'],

  components: {
    // use this component to calculate auto width1
    LabelWrap: label_wrap,
    ElTooltip: tooltip_default.a
  },

  props: {
    label: String,
    labelWidth: [String, Object],
    wrapperWidth: Object,
    prop: String,
    required: {
      type: Boolean,
      default: undefined
    },
    rules: [Object, Array],
    error: String,
    validateStatus: String,
    for: String,
    inlineMessage: {
      type: [String, Boolean],
      default: ''
    },
    showMessage: {
      type: Boolean,
      default: true
    },
    size: String,
    tooltip: String
  },
  watch: {
    error: {
      immediate: true,
      handler: function handler(value) {
        this.validateMessage = value;
        this.validateState = value ? 'error' : '';
      }
    },
    validateStatus: function validateStatus(value) {
      this.validateState = value;
    }
  },
  computed: {
    labelFor: function labelFor() {
      return this.for || this.prop;
    },
    labelStyle: function labelStyle() {
      var ret = {};
      if (this.form.labelPosition === 'top') return ret;
      var labelWidth = this.labelWidth || this.form.labelWidth;
      if (labelWidth) {
        ret.width = labelWidth;
      }
      return ret;
    },
    contentStyle: function contentStyle() {
      var ret = {};
      var label = this.label;
      if (this.form.labelPosition === 'top' || this.form.inline) return ret;
      if (!label && !this.labelWidth && this.isNested) return ret;
      var labelWidth = this.labelWidth || this.form.labelWidth;
      if (labelWidth === 'auto') {
        if (this.labelWidth === 'auto') {
          ret.marginLeft = this.computedLabelWidth;
        } else if (this.form.labelWidth === 'auto') {
          ret.marginLeft = this.elForm.autoLabelWidth;
        }
      } else {
        ret.marginLeft = labelWidth;
      }
      return ret;
    },
    form: function form() {
      var parent = this.$parent;
      var parentName = parent.$options.componentName;
      while (parentName !== 'ElForm') {
        if (parentName === 'ElFormItem') {
          this.isNested = true;
        }
        parent = parent.$parent;
        parentName = parent.$options.componentName;
      }
      return parent;
    },
    fieldValue: function fieldValue() {
      var model = this.form.model;
      if (!model || !this.prop) {
        return;
      }

      var path = this.prop;
      if (path.indexOf(':') !== -1) {
        path = path.replace(/:/, '.');
      }

      return Object(util_["getPropByPath"])(model, path, true).v;
    },
    isRequired: function isRequired() {
      var rules = this.getRules();
      var isRequired = false;

      if (rules && rules.length) {
        rules.every(function (rule) {
          if (rule.required) {
            isRequired = true;
            return false;
          }
          return true;
        });
      }
      return isRequired;
    },
    _formSize: function _formSize() {
      return this.elForm.size;
    },
    elFormItemSize: function elFormItemSize() {
      return this.size || this._formSize;
    },
    sizeClass: function sizeClass() {
      return this.elFormItemSize || (this.$ELEMENT || {}).size;
    },
    responsiveMode: function responsiveMode() {
      return this.labelWidth && _typeof(this.labelWidth) === 'object';
    }
  },
  data: function data() {
    return {
      validateState: '',
      validateMessage: '',
      validateDisabled: false,
      validator: {},
      isNested: false,
      computedLabelWidth: ''
    };
  },

  methods: {
    validate: function validate(trigger) {
      var _this = this;

      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : util_["noop"];

      this.validateDisabled = false;
      var rules = this.getFilteredRule(trigger);
      if ((!rules || rules.length === 0) && this.required === undefined) {
        callback();
        return true;
      }

      this.validateState = 'validating';

      var descriptor = {};
      if (rules && rules.length > 0) {
        rules.forEach(function (rule) {
          delete rule.trigger;
        });
      }
      descriptor[this.prop] = rules;

      var validator = new external_async_validator_default.a(descriptor);
      var model = {};

      model[this.prop] = this.fieldValue;

      validator.validate(model, { firstFields: true }, function (errors, invalidFields) {
        _this.validateState = !errors ? 'success' : 'error';
        _this.validateMessage = errors ? errors[0].message : '';

        callback(_this.validateMessage, invalidFields);
        _this.elForm && _this.elForm.$emit('validate', _this.prop, !errors, _this.validateMessage || null);
      });
    },
    clearValidate: function clearValidate() {
      this.validateState = '';
      this.validateMessage = '';
      this.validateDisabled = false;
    },
    resetField: function resetField() {
      var _this2 = this;

      this.validateState = '';
      this.validateMessage = '';

      var model = this.form.model;
      var value = this.fieldValue;
      var path = this.prop;
      if (path.indexOf(':') !== -1) {
        path = path.replace(/:/, '.');
      }

      var prop = Object(util_["getPropByPath"])(model, path, true);

      this.validateDisabled = true;
      if (Array.isArray(value)) {
        prop.o[prop.k] = [].concat(this.initialValue);
      } else {
        prop.o[prop.k] = this.initialValue;
      }

      // reset validateDisabled after onFieldChange triggered
      this.$nextTick(function () {
        _this2.validateDisabled = false;
      });

      this.broadcast('ElTimeSelect', 'fieldReset', this.initialValue);
    },
    getRules: function getRules() {
      var formRules = this.form.rules;
      var selfRules = this.rules;
      var requiredRule = this.required !== undefined ? { required: !!this.required } : [];

      var prop = Object(util_["getPropByPath"])(formRules, this.prop || '');
      formRules = formRules ? prop.o[this.prop || ''] || prop.v : [];

      return [].concat(selfRules || formRules || []).concat(requiredRule);
    },
    getFilteredRule: function getFilteredRule(trigger) {
      var rules = this.getRules();

      return rules.filter(function (rule) {
        if (!rule.trigger || trigger === '') return true;
        if (Array.isArray(rule.trigger)) {
          return rule.trigger.indexOf(trigger) > -1;
        } else {
          return rule.trigger === trigger;
        }
      }).map(function (rule) {
        return merge_default()({}, rule);
      });
    },
    onFieldBlur: function onFieldBlur() {
      this.validate('blur');
    },
    onFieldChange: function onFieldChange() {
      if (this.validateDisabled) {
        this.validateDisabled = false;
        return;
      }

      this.validate('change');
    },
    updateComputedLabelWidth: function updateComputedLabelWidth(width) {
      this.computedLabelWidth = width ? width + 'px' : '';
    },
    addValidateEvents: function addValidateEvents() {
      var rules = this.getRules();

      if (rules.length || this.required !== undefined) {
        this.$on('el.form.blur', this.onFieldBlur);
        this.$on('el.form.change', this.onFieldChange);
      }
    },
    removeValidateEvents: function removeValidateEvents() {
      this.$off();
    }
  },
  mounted: function mounted() {
    if (this.prop) {
      this.dispatch('ElForm', 'el.form.addField', [this]);

      var initialValue = this.fieldValue;
      if (Array.isArray(initialValue)) {
        initialValue = [].concat(initialValue);
      }
      Object.defineProperty(this, 'initialValue', {
        value: initialValue
      });

      this.addValidateEvents();
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.dispatch('ElForm', 'el.form.removeField', [this]);
  }
});
// CONCATENATED MODULE: ./packages/form/src/form-item.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_form_itemvue_type_script_lang_js_ = (form_itemvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./packages/form/src/form-item.vue





/* normalize component */

var form_item_component = Object(componentNormalizer["a" /* default */])(
  src_form_itemvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var form_item_api; }
form_item_component.options.__file = "packages/form/src/form-item.vue"
/* harmony default export */ var form_item = __webpack_exports__["a"] = (form_item_component.exports);

/***/ }),

/***/ 33:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/form/src/form.vue?vue&type=template&id=a1b5ff34&
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "el-form",
      class: [
        _vm.labelPosition ? "el-form--label-" + _vm.labelPosition : "",
        { "el-form--inline": _vm.inline },
        _vm.labelSuffix !== "" ? "el-form-has-label-suffix" : ""
      ],
      on: {
        keyup: function($event) {
          if (
            !("button" in $event) &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          ) {
            return null
          }
          $event.preventDefault()
          _vm.handleSubmit($event)
        }
      }
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/form/src/form.vue?vue&type=template&id=a1b5ff34&

// EXTERNAL MODULE: external "setaria-ui/lib/utils/merge"
var merge_ = __webpack_require__(9);
var merge_default = /*#__PURE__*/__webpack_require__.n(merge_);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/form/src/form.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var formvue_type_script_lang_js_ = ({
  name: 'ElForm',

  componentName: 'ElForm',

  provide: function provide() {
    return {
      elForm: this
    };
  },


  props: {
    model: Object,
    rules: Object,
    labelPosition: String,
    labelWidth: {
      type: String,
      default: 'auto'
    },
    labelSuffix: {
      type: String,
      default: ''
    },
    inline: Boolean,
    inlineMessage: Boolean,
    statusIcon: Boolean,
    showMessage: {
      type: Boolean,
      default: true
    },
    size: String,
    disabled: Boolean,
    validateOnRuleChange: {
      type: Boolean,
      default: true
    },
    hideRequiredAsterisk: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    rules: function rules() {
      // remove then add event listeners on form-item after form rules change
      this.fields.forEach(function (field) {
        field.removeValidateEvents();
        field.addValidateEvents();
      });

      if (this.validateOnRuleChange) {
        this.validate(function () {});
      }
    }
  },
  computed: {
    autoLabelWidth: function autoLabelWidth() {
      if (!this.potentialLabelWidthArr.length) return 0;
      var max = Math.max.apply(Math, this.potentialLabelWidthArr);
      return max ? max + 'px' : '';
    }
  },
  data: function data() {
    return {
      fields: [],
      potentialLabelWidthArr: [] // use this array to calculate auto width
    };
  },
  created: function created() {
    var _this = this;

    this.$on('el.form.addField', function (field) {
      if (field) {
        _this.fields.push(field);
      }
    });
    /* istanbul ignore next */
    this.$on('el.form.removeField', function (field) {
      if (field.prop) {
        _this.fields.splice(_this.fields.indexOf(field), 1);
      }
    });
  },

  methods: {
    resetFields: function resetFields() {
      if (!this.model) {
        console.warn('[Element Warn][Form]model is required for resetFields to work.');
        return;
      }
      this.fields.forEach(function (field) {
        field.resetField();
      });
    },
    clearValidate: function clearValidate() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      var fields = props.length ? typeof props === 'string' ? this.fields.filter(function (field) {
        return props === field.prop;
      }) : this.fields.filter(function (field) {
        return props.indexOf(field.prop) > -1;
      }) : this.fields;
      fields.forEach(function (field) {
        field.clearValidate();
      });
    },
    validate: function validate(callback) {
      var _this2 = this;

      if (!this.model) {
        console.warn('[Element Warn][Form]model is required for validate to work!');
        return;
      }
      var promise = void 0;
      // if no callback, return promise
      if (typeof callback !== 'function' && window.Promise) {
        promise = new window.Promise(function (resolve, reject) {
          callback = function callback(valid) {
            valid ? resolve(valid) : reject(valid);
          };
        });
      }

      var valid = true;
      var count = 0;
      // 如果需要验证的fields为空，调用验证时立刻返回callback
      if (this.fields.length === 0 && callback) {
        callback(true);
      }
      var invalidFields = {};
      this.fields.forEach(function (field) {
        field.validate('', function (message, field) {
          if (message) {
            valid = false;
          }
          invalidFields = merge_default()({}, invalidFields, field);
          if (typeof callback === 'function' && ++count === _this2.fields.length) {
            callback(valid, invalidFields);
          }
        });
      });

      if (promise) {
        return promise;
      }
    },
    validateField: function validateField(props, cb) {
      props = [].concat(props);
      var fields = this.fields.filter(function (field) {
        return props.indexOf(field.prop) !== -1;
      });
      if (!fields.length) {
        console.warn('[Element Warn]please pass correct props!');
        return;
      }

      fields.forEach(function (field) {
        field.validate('', cb);
      });
    },
    handleSubmit: function handleSubmit(event) {
      // 触发submit事件
      this.$emit('submit');
    },
    getLabelWidthIndex: function getLabelWidthIndex(width) {
      var index = this.potentialLabelWidthArr.indexOf(width);
      // it's impossible
      if (index === -1) {
        console.error('[ElementForm]unpected width ', width);
      }
      return index;
    },
    registerLabelWidth: function registerLabelWidth(val, oldVal) {
      if (val && oldVal) {
        var index = this.getLabelWidthIndex(oldVal);
        this.potentialLabelWidthArr.splice(index, 1, val);
      } else if (val) {
        this.potentialLabelWidthArr.push(val);
      }
    },
    deregisterLabelWidth: function deregisterLabelWidth(val) {
      var index = this.getLabelWidthIndex(val);
      this.potentialLabelWidthArr.splice(index, 1);
    }
  }
});
// CONCATENATED MODULE: ./packages/form/src/form.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_formvue_type_script_lang_js_ = (formvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./packages/form/src/form.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_formvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "packages/form/src/form.vue"
/* harmony default export */ var src_form = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ 37:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var setaria_ui_src_constants_index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6);
/* harmony import */ var setaria_ui_packages_form_src_form__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33);
/* harmony import */ var setaria_ui_packages_form_src_form_item__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32);
/* harmony import */ var setaria_ui_packages_select__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27);
/* harmony import */ var setaria_ui_packages_select__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(setaria_ui_packages_select__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var setaria_ui_packages_input__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12);
/* harmony import */ var setaria_ui_packages_input__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(setaria_ui_packages_input__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var setaria_ui_src_utils_merge__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9);
/* harmony import */ var setaria_ui_src_utils_merge__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(setaria_ui_src_utils_merge__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var setaria_ui_src_utils_schema__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(20);
/* harmony import */ var setaria_ui_src_utils_schema__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(setaria_ui_src_utils_schema__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var setaria_ui_src_utils_util__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2);
/* harmony import */ var setaria_ui_src_utils_util__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(setaria_ui_src_utils_util__WEBPACK_IMPORTED_MODULE_7__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };










var CLASSNAME = 'className';

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ElJsonForm',
  componentName: 'ElJsonForm',
  props: {
    model: Object,
    // 表单提交是否重载页面
    isPrevent: {
      type: Boolean,
      default: true
    },
    schema: {
      type: Object,
      required: true
    },
    uiSchema: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    columns: {
      type: Number,
      default: 4
    },
    componentPrefix: {
      type: String,
      default: 'el'
    },
    columnMaxLabelLength: Number,
    rules: Object
  },
  data: function data() {
    return {};
  },

  computed: {
    innerRules: function innerRules() {
      var _rules = this.rules,
          rules = _rules === undefined ? {} : _rules;

      var ret = Object(setaria_ui_src_utils_schema__WEBPACK_IMPORTED_MODULE_6__["createFormRulesBySchema"])(this.schema, this.uiSchema);
      return setaria_ui_src_utils_merge__WEBPACK_IMPORTED_MODULE_5___default()({}, ret, rules);
    },
    fields: function fields() {
      if (this.$refs.form) {
        return this.$refs.form.fields;
      }
      return [];
    }
  },
  created: function created() {},
  mounted: function mounted() {},

  methods: {
    handleSubmit: function handleSubmit() {
      this.$emit('submit');
    },
    validate: function validate(callback) {
      return this.$refs.form.validate(callback);
    },
    validateField: function validateField(props, cb) {
      return this.$refs.form.validateField(props, cb);
    },
    resetFields: function resetFields() {
      this.$refs.form.resetFields();
    },
    getFormLabelSlot: function getFormLabelSlot(h, property, columnMaxLabelLength, colSpan) {
      var componentPrefix = this.componentPrefix;

      var span = typeof colSpan === 'number' ? colSpan : 1;
      var ret = null;
      var textSpan = null;
      var tooltip = null;
      var slotChildren = [];
      if (typeof columnMaxLabelLength === 'number') {
        var ellipsis = h(componentPrefix + '-ellipsis', {
          props: {
            tooltip: true,
            'full-width-recognition': true,
            length: columnMaxLabelLength * span
          }
        }, [property.title]);
        textSpan = h('div', {
          'class': ['label-inner__ellipsis']
        }, [ellipsis]);
      }
      if (!Object(setaria_ui_src_utils_util__WEBPACK_IMPORTED_MODULE_7__["isEmpty"])(property.description)) {
        if (textSpan === null) {
          textSpan = h('span', {
            domProps: {
              innerHTML: property.title
            }
          });
        }
        var icon = h(componentPrefix + '-icon', {
          props: {
            name: 'warning-outline',
            tooltip: false
          },
          style: {
            cursor: 'auto'
          }
        });
        tooltip = h(componentPrefix + '-tooltip', {
          props: {
            placement: 'top'
          },
          style: {
            marginLeft: '5px'
          }
        }, [icon, h('span', {
          domProps: {
            innerHTML: property.description
          },
          slot: 'content',
          style: {
            display: 'inline-block',
            maxWidth: '400px'
          }
        })]);
      }
      if (textSpan) {
        slotChildren.push(textSpan);
      }
      if (tooltip) {
        slotChildren.push(tooltip);
      }
      if (slotChildren.length > 0) {
        ret = function ret(props) {
          return h('div', {
            class: {
              'el-json-form__label-inner': true
            }
          }, slotChildren);
        };
      }
      return ret;
    }
  },
  render: function render(h) {
    var _this = this;

    // model属性必须设置，否则表单内组件无法正确进行相应
    if (Object(setaria_ui_src_utils_util__WEBPACK_IMPORTED_MODULE_7__["isEmpty"])(this.model)) {
      console.warn('表单组件的model属性需要设置非空值。');
      return null;
    }
    var self = this;
    var componentPrefix = self.componentPrefix,
        $scopedSlots = self.$scopedSlots;

    var formItemArray = [];
    var formEvents = {
      on: {}
    };
    formEvents.on.submit = function () {
      _this.handleSubmit();
    };
    var model = this.model;
    if (this.schema && this.schema.properties) {
      Object.keys(this.schema.properties).forEach(function (key) {
        var ui = _this.uiSchema[key] || {};
        var formItem = null;
        var property = self.schema.properties[key];
        // title不为空的场合，基于schema进行渲染
        if (!Object(setaria_ui_src_utils_util__WEBPACK_IMPORTED_MODULE_7__["isEmpty"])(property.title)) {
          var formItemChildren = [];
          if ($scopedSlots[key] === undefined) {
            var className = ui[CLASSNAME] || '';
            var component = Object(setaria_ui_src_utils_schema__WEBPACK_IMPORTED_MODULE_6__["createElementByProperty"])(key, property, ui, model, _this.$emit);
            if (component) {
              component.componentProps.class = 'el-json-form__component ' + className;
              var componentTagName = component.componentTagName,
                  componentProps = component.componentProps,
                  componentChildrenOptions = component.componentChildrenOptions;

              var componentChildren = [];
              componentChildrenOptions.forEach(function (item) {
                if (componentTagName === 'el-select') {
                  componentChildren.push(h('el-option', {
                    props: {
                      label: item.label,
                      value: item.value,
                      disabled: item.disabled
                    }
                  }));
                } else if (componentTagName === 'el-radio-group') {
                  componentChildren.push(h('el-radio', {
                    props: {
                      label: item.value
                    }
                  }, [item.label]));
                } else if (componentTagName === 'el-checkbox-group') {
                  componentChildren.push(h('el-checkbox', {
                    props: {
                      label: item.value
                    }
                  }, [item.label]));
                }
              });
              formItemChildren.push(h(componentTagName, componentProps, componentChildren));
            }
          } else {
            var childrenCustomRender = $scopedSlots[key]({ data: model });
            formItemChildren.push(childrenCustomRender);
          }
          var labelSlot = self.getFormLabelSlot(h, property, self.columnMaxLabelLength, colSpan);
          var colSpan = ui[setaria_ui_src_constants_index__WEBPACK_IMPORTED_MODULE_0__[/* JSON_FORM_UI */ "c"].UI_COLSPAN];
          formItem = h(componentPrefix + '-form-item', {
            'class': ['el-form-item-' + key, 'el-json-form-item'],
            props: {
              label: property.title,
              prop: key
            },
            scopedSlots: {
              label: labelSlot
            }
          }, [formItemChildren]);
        } else if (typeof ui[setaria_ui_src_constants_index__WEBPACK_IMPORTED_MODULE_0__[/* JSON_FORM_UI */ "c"].UI_RENDER] === 'function') {
          formItem = ui[setaria_ui_src_constants_index__WEBPACK_IMPORTED_MODULE_0__[/* JSON_FORM_UI */ "c"].UI_RENDER](h, { data: model });
        }
        if (!Object(setaria_ui_src_utils_util__WEBPACK_IMPORTED_MODULE_7__["isEmpty"])(formItem)) {
          formItemArray.push({
            id: key,
            component: formItem
          });
        }
      });
    }
    var $attrs = this.$attrs;

    var formProps = _extends({}, $attrs, {
      model: model,
      rules: self.innerRules,
      isPrevent: self.isPrevent
    });
    var formComponents = formItemArray;
    // inline模式的场合不使用自适应
    if (this.$attrs.inline !== true) {
      // 自适应设置
      var rowArray = [];
      var colArray = [];
      // let totalSpanCount = 0;
      for (var index = 0; index < formItemArray.length; index += 1) {
        var formItem = formItemArray[index];
        var itemUISchema = this.uiSchema[formItem.id] || {};
        var uiColspan = itemUISchema[setaria_ui_src_constants_index__WEBPACK_IMPORTED_MODULE_0__[/* JSON_FORM_UI */ "c"].UI_COLSPAN];
        uiColspan = uiColspan > self.columns ? self.columns : uiColspan;
        var spanProp = null;
        var span = typeof uiColspan === 'number' ? 24 / self.columns * uiColspan : 24 / self.columns;
        // 考虑columns属性为5的场合
        if (self.columns === 5) {
          switch (uiColspan) {
            case 1:
              spanProp = '4-8';
              break;
            case 2:
              spanProp = '9-6';
              break;
            case 3:
              spanProp = '14-4';
              break;
            case 4:
              spanProp = '19-2';
              break;
            case 5:
              spanProp = '24';
              break;
            default:
              spanProp = '4-8';
          }
        } else {
          spanProp = span;
        }
        var isDisplay = itemUISchema[setaria_ui_src_constants_index__WEBPACK_IMPORTED_MODULE_0__[/* JSON_FORM_UI */ "c"].UI_HIDDEN];
        if (typeof itemUISchema[setaria_ui_src_constants_index__WEBPACK_IMPORTED_MODULE_0__[/* JSON_FORM_UI */ "c"].UI_HIDDEN] === 'function') {
          isDisplay = itemUISchema[setaria_ui_src_constants_index__WEBPACK_IMPORTED_MODULE_0__[/* JSON_FORM_UI */ "c"].UI_HIDDEN](model);
        }
        var column = h(componentPrefix + '-col', {
          props: {
            span: spanProp,
            xs: 24
          },
          style: {
            display: isDisplay ? 'none' : ''
          }
        }, [formItem.component]);
        colArray.push(column);
      }
      if (this.$slots.formItems) {
        colArray.push(this.$slots.formItems);
      }
      var labelWidth = self.$attrs['label-width'];
      var gutter = labelWidth === undefined || labelWidth === null ? 10 : 20;
      var row = h(componentPrefix + '-row', {
        props: {
          gutter: gutter
        }
      }, [].concat(colArray));
      rowArray.push(row);
      formComponents = rowArray;
    } else {
      formComponents = formItemArray.map(function (item) {
        return item.component;
      });
    }
    return h(componentPrefix + '-form', {
      'class': 'el-json-form',
      props: formProps,
      on: formEvents.on,
      ref: 'form'
    }, [].concat(formComponents, [self.$slots.default, self.$slots.button]));
  },

  components: {
    ElForm: setaria_ui_packages_form_src_form__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"],
    ElFormItem: setaria_ui_packages_form_src_form_item__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"],
    ElSelect: setaria_ui_packages_select__WEBPACK_IMPORTED_MODULE_3___default.a,
    ElInput: setaria_ui_packages_input__WEBPACK_IMPORTED_MODULE_4___default.a
  }
});

/***/ }),

/***/ 38:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/card/src/main.vue?vue&type=template&id=59a4a40f&
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "el-card",
      class: [
        _vm.shadow ? "is-" + _vm.shadow + "-shadow" : "is-always-shadow",
        _vm.collapse ? "is-collapse" : "",
        _vm.cardSize ? "el-card--" + _vm.cardSize : "",
        _vm.type ? "el-card--" + _vm.type : ""
      ]
    },
    [
      _vm.$slots.header || _vm.header || _vm.tabList
        ? _c(
            "div",
            {
              ref: "header",
              class: ["el-card__header", _vm.tabList ? "is-tab" : ""],
              on: { click: _vm.handleHeaderClick }
            },
            [
              _vm.collapse
                ? _c(
                    "a",
                    {
                      staticClass: "header__expander",
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.handleExpandIconClick($event)
                        }
                      }
                    },
                    [
                      _c("i", {
                        class: {
                          "el-icon-arrow-down": !_vm.innerExpand,
                          "el-icon-arrow-up": _vm.innerExpand
                        }
                      })
                    ]
                  )
                : _vm._e(),
              _c(
                "div",
                {
                  ref: "headerContainer",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.handleHeaderClick($event)
                    }
                  }
                },
                [
                  _vm._t("header", [
                    _vm._v("\n        " + _vm._s(_vm.header) + "\n      ")
                  ])
                ],
                2
              ),
              _vm.tabList
                ? _c(
                    "div",
                    { staticClass: "el-tabs__header is-top" },
                    [
                      _c("tab-nav", {
                        attrs: {
                          data: _vm.tabList,
                          onTabClick: _vm.handleTabClick,
                          "active-tab-name": _vm.activeTabName
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ]
          )
        : _vm._e(),
      _vm.$slots.cover
        ? _c("div", { staticClass: "el-card__cover" }, [_vm._t("cover")], 2)
        : _vm._e(),
      _vm.collapse
        ? _c("el-collapse-transition", [
            _vm.$slots.default
              ? _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.innerExpand,
                        expression: "innerExpand"
                      }
                    ],
                    staticClass: "el-card__body",
                    style: _vm.bodyStyle
                  },
                  [_vm._t("default")],
                  2
                )
              : _vm._e()
          ])
        : [
            _vm.$slots.default
              ? _c(
                  "div",
                  { staticClass: "el-card__body", style: _vm.bodyStyle },
                  [_vm._t("default")],
                  2
                )
              : _vm._e()
          ],
      _vm.$slots.actions
        ? _c("ul", { staticClass: "el-card__actions" }, [_vm._t("actions")], 2)
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/card/src/main.vue?vue&type=template&id=59a4a40f&

// EXTERNAL MODULE: external "setaria-ui/lib/tab-nav"
var tab_nav_ = __webpack_require__(55);
var tab_nav_default = /*#__PURE__*/__webpack_require__.n(tab_nav_);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/card/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



function getParentNode(dom, level) {
  var ret = [];
  if (dom) {
    for (var i = 0; i < level; i++) {
      if (i === 0) {
        ret.push(dom.parentNode);
      } else if (ret[ret.length - 1]) {
        ret.push(ret[ret.length - 1].parentNode);
      }
    }
  }
  return ret;
}

/* harmony default export */ var mainvue_type_script_lang_js_ = ({
  name: 'ElCard',
  componentName: 'ElCard',
  provide: function provide() {
    return {
      elCard: this
    };
  },

  props: {
    header: {},
    bodyStyle: {},
    shadow: {
      type: String
    },
    activeTabName: null,
    tabList: null,
    type: String,
    size: String,
    collapse: {
      type: Boolean,
      default: false
    },
    value: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      actionItemList: [],
      innerExpand: true
    };
  },

  watch: {
    value: {
      immediate: true,
      handler: function handler(val) {
        this.innerExpand = val;
      }
    },
    innerExpand: function innerExpand(val) {
      this.$emit('input', val);
    }
  },
  computed: {
    cardSize: function cardSize() {
      return this.size || (this.$ELEMENT || {}).size;
    }
  },
  created: function created() {
    var _this = this;

    this.$on('el.card.addActionItem', function (actionItem) {
      if (actionItem) {
        _this.actionItemList.push(actionItem);
      }
    });
  },

  methods: {
    handleExpandIconClick: function handleExpandIconClick() {
      this.innerExpand = !this.innerExpand;
    },
    handleHeaderClick: function handleHeaderClick(e) {
      if (e && e.target) {
        var triggerExpand = false;
        if (e.target === this.$refs.header) {
          triggerExpand = true;
        }
        var parentNodeList = getParentNode(e.target, 2);
        if (e.target !== this.$refs.header && parentNodeList.length > 0) {
          if (parentNodeList[0] === this.$refs.headerContainer || parentNodeList[0] === this.$refs.header) {
            triggerExpand = true;
          }
        }
        if (triggerExpand) {
          // 触发卡片内容折叠事件
          this.handleExpandIconClick();
        }
      }
    },
    handleTabClick: function handleTabClick(tab, ev) {
      this.$emit('tab-click', tab, ev);
      this.$emit('update:activeTabName', tab.name);
    }
  },
  components: {
    TabNav: tab_nav_default.a
  }
});
// CONCATENATED MODULE: ./packages/card/src/main.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_mainvue_type_script_lang_js_ = (mainvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./packages/card/src/main.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_mainvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "packages/card/src/main.vue"
/* harmony default export */ var main = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ 39:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/dialog/src/component.vue?vue&type=template&id=60140e62&
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    {
      attrs: { name: "dialog-fade" },
      on: { "after-enter": _vm.afterEnter, "after-leave": _vm.afterLeave }
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.visible,
              expression: "visible"
            }
          ],
          ref: "dialogWrapper",
          staticClass: "el-dialog__wrapper",
          style: _vm.wrapperStyle,
          on: {
            click: function($event) {
              if ($event.target !== $event.currentTarget) {
                return null
              }
              return _vm.handleWrapperClick($event)
            }
          }
        },
        [
          _c(
            "div",
            {
              key: _vm.key,
              ref: "dialog",
              class: [
                "el-dialog",
                {
                  "is-fullscreen": _vm.fullscreen,
                  "el-dialog--center": _vm.center
                },
                _vm.customClass
              ],
              style: _vm.style,
              attrs: {
                role: "dialog",
                "aria-modal": "true",
                "aria-label": _vm.title || "dialog"
              }
            },
            [
              _c(
                "button",
                {
                  staticClass: "el-dialog__headerbtn",
                  attrs: { type: "button" }
                },
                [
                  _vm.isShowBrowserFullscreenIcon
                    ? _c("i", {
                        staticClass: "el-dialog__fullscreen el-icon",
                        class: {
                          "el-icon-full-screen": !_vm.dialogFullscreen,
                          "el-icon-copy-document": _vm.dialogFullscreen
                        },
                        attrs: { "aria-label": "Fullscreen" },
                        on: { click: _vm.handleFullscreen }
                      })
                    : _vm._e(),
                  _vm.showClose
                    ? _c("i", {
                        staticClass: "el-dialog__close el-icon el-icon-close",
                        attrs: { "aria-label": "Close" },
                        on: { click: _vm.handleClose }
                      })
                    : _vm._e()
                ]
              ),
              _vm.$slots.title || _vm.title !== ""
                ? _c(
                    "div",
                    { staticClass: "el-dialog__header" },
                    [
                      _vm._t("title", [
                        _c("span", { staticClass: "el-dialog__title" }, [
                          _vm._v(_vm._s(_vm.title))
                        ])
                      ])
                    ],
                    2
                  )
                : _vm._e(),
              _vm.rendered
                ? _c(
                    "div",
                    { staticClass: "el-dialog__body" },
                    [_vm._t("default")],
                    2
                  )
                : _vm._e(),
              _vm.$slots.footer
                ? _c(
                    "div",
                    { staticClass: "el-dialog__footer" },
                    [_vm._t("footer")],
                    2
                  )
                : _vm._e()
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/dialog/src/component.vue?vue&type=template&id=60140e62&

// EXTERNAL MODULE: external "draggabilly"
var external_draggabilly_ = __webpack_require__(50);
var external_draggabilly_default = /*#__PURE__*/__webpack_require__.n(external_draggabilly_);

// EXTERNAL MODULE: external "setaria-ui/lib/utils/popup"
var popup_ = __webpack_require__(17);
var popup_default = /*#__PURE__*/__webpack_require__.n(popup_);

// EXTERNAL MODULE: external "setaria-ui/lib/mixins/migrating"
var migrating_ = __webpack_require__(13);
var migrating_default = /*#__PURE__*/__webpack_require__.n(migrating_);

// EXTERNAL MODULE: external "setaria-ui/lib/mixins/emitter"
var emitter_ = __webpack_require__(5);
var emitter_default = /*#__PURE__*/__webpack_require__.n(emitter_);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/dialog/src/component.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var componentvue_type_script_lang_js_ = ({
  name: 'ElDialog',

  mixins: [popup_default.a, emitter_default.a, migrating_default.a],

  props: {
    title: {
      type: String,
      default: ''
    },

    modal: {
      type: Boolean,
      default: true
    },

    modalAppendToBody: {
      type: Boolean,
      default: true
    },

    appendToBody: {
      type: Boolean,
      default: false
    },

    lockScroll: {
      type: Boolean,
      default: true
    },

    closeOnClickModal: {
      type: Boolean,
      default: true
    },

    closeOnPressEscape: {
      type: Boolean,
      default: true
    },

    showClose: {
      type: Boolean,
      default: true
    },

    width: String,

    fullscreen: Boolean,

    customClass: {
      type: String,
      default: ''
    },

    top: {
      type: String,
      default: '15vh'
    },
    beforeClose: Function,
    center: {
      type: Boolean,
      default: false
    },
    dragable: {
      type: Boolean,
      default: true
    },
    destroyOnClose: Boolean,
    browserFullscreen: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      closed: false,
      key: 0,
      dialogFullscreen: false
    };
  },


  watch: {
    visible: function visible(val) {
      var _this = this;

      if (val) {
        this.closed = false;
        this.$emit('open');
        this.$el.addEventListener('scroll', this.updatePopper);
        this.$nextTick(function () {
          _this.$refs.dialog.scrollTop = 0;
        });
        if (this.appendToBody) {
          document.body.appendChild(this.$el);
        }
      } else {
        this.exitFullscreen();
        this.$el.removeEventListener('scroll', this.updatePopper);
        if (!this.closed) this.$emit('close');
        if (this.destroyOnClose) {
          this.$nextTick(function () {
            _this.key++;
          });
        }
      }
    }
  },

  computed: {
    wrapperStyle: function wrapperStyle() {
      var ret = {};
      if (this.size !== 'full' && !this.top) {
        ret = {
          'display': 'flex',
          'align-items': 'center',
          'justify-content': 'center'
        };
      }
      return ret;
    },
    style: function style() {
      var style = {};
      if (!this.fullscreen) {
        style.marginTop = this.top;
        if (this.width) {
          style.width = this.width;
        }
      }
      return style;
    },
    isShowBrowserFullscreenIcon: function isShowBrowserFullscreenIcon() {
      return this.browserFullscreen && document.exitFullscreen;
    }
  },

  created: function created() {
    var _this2 = this;

    /*eslint no-new: "error"*/
    this.$nextTick(function () {
      if (_this2.dragable) {
        /*eslint no-unused-vars: ["error", { "varsIgnorePattern": "drag" }]*/
        var drag = new external_draggabilly_default.a(_this2.$refs.dialog, {
          containment: _this2.$refs.dialogWrapper,
          handle: '.el-dialog__header'
        });
        drag.on('dragStart', function (e, pointer) {
          _this2.$emit('drag-start', e, pointer);
        });
        drag.on('dragMove', function (e, pointer, moveVector) {
          _this2.$emit('drag-move', e, pointer, moveVector);
        });
        drag.on('dragEnd', function (e, pointer) {
          _this2.$emit('drag-end', e, pointer);
        });
      }
    });
  },


  methods: {
    getMigratingConfig: function getMigratingConfig() {
      return {
        props: {
          'size': 'size is removed.'
        }
      };
    },
    handleWrapperClick: function handleWrapperClick() {
      if (!this.closeOnClickModal) return;
      this.handleClose();
    },
    handleClose: function handleClose() {
      // 全屏显示的场合，需要先退出全屏模式
      if (typeof this.beforeClose === 'function') {
        this.exitFullscreen();
        this.beforeClose(this.hide);
      } else {
        this.hide();
      }
    },
    exitFullscreen: function exitFullscreen() {
      if (this.dialogFullscreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
          this.dialogFullscreen = !this.dialogFullscreen;
        }
      }
    },
    handleFullscreen: function handleFullscreen() {
      if (!this.dialogFullscreen) {
        if (this.$refs.dialog.requestFullscreen) {
          this.$refs.dialog.requestFullscreen();
          this.dialogFullscreen = !this.dialogFullscreen;
        }
        return;
      }
      this.exitFullscreen();
    },
    hide: function hide(cancel) {
      if (cancel !== false) {
        this.exitFullscreen();
        this.$emit('update:visible', false);
        this.$emit('close');
        this.closed = true;
      }
    },
    updatePopper: function updatePopper() {
      this.broadcast('ElSelectDropdown', 'updatePopper');
      this.broadcast('ElDropdownMenu', 'updatePopper');
    },
    afterEnter: function afterEnter() {
      this.$emit('opened');
    },
    afterLeave: function afterLeave() {
      this.$emit('closed');
    }
  },

  mounted: function mounted() {
    if (this.visible) {
      this.rendered = true;
      this.open();
      if (this.appendToBody) {
        document.body.appendChild(this.$el);
      }
    }
  },
  destroyed: function destroyed() {
    // if appendToBody is true, remove DOM node after destroy
    if (this.appendToBody && this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  }
});
// CONCATENATED MODULE: ./packages/dialog/src/component.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_componentvue_type_script_lang_js_ = (componentvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./packages/dialog/src/component.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_componentvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "packages/dialog/src/component.vue"
/* harmony default export */ var src_component = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = require("setaria-ui/lib/utils/dom");

/***/ }),

/***/ 43:
/***/ (function(module, exports) {

module.exports = require("async-validator");

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("setaria-ui/lib/mixins/emitter");

/***/ }),

/***/ 50:
/***/ (function(module, exports) {

module.exports = require("draggabilly");

/***/ }),

/***/ 55:
/***/ (function(module, exports) {

module.exports = require("setaria-ui/lib/tab-nav");

/***/ }),

/***/ 6:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return JSON_FORM_UI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return COLUMN_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return EDIT_TYPE; });
var JSON_FORM_UI = {
  UI_WIDGET: 'ui:widget',
  UI_OPTIONS: 'ui:options',
  UI_DISABLED: 'ui:disabled',
  UI_HIDDEN: 'ui:hidden',
  UI_FORMAT: 'ui:format',
  UI_ON: 'ui:on',
  UI_NATIVE_ON: 'ui:nativeOn',
  UI_PARENT_COLUMN_ID: 'ui:parentColumnId',
  UI_RULES: 'ui:rules',
  UI_PLACEHOLDER: 'ui:placeholder',
  UI_COLSPAN: 'ui:colspan',
  UI_RULE: 'ui:rules',
  UI_RENDER: 'ui:render'
};

var COLUMN_TYPE = {
  INDEX: 'index'
};

var EDIT_TYPE = {
  ADD: 'add',
  DELETE: 'delete',
  MODIFY: 'modify'
};

/* unused harmony default export */ var _unused_webpack_default_export = ({});

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("setaria-ui/lib/utils/merge");

/***/ })

/******/ });